import { render, staticRenderFns } from "./SearchWithAutoComplete.vue?vue&type=template&id=23cd879f&"
import script from "./SearchWithAutoComplete.vue?vue&type=script&lang=js&"
export * from "./SearchWithAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports